const VocabProMenu = {
  information_management: ['Gestión de información', 'Information Management'],
  
  // Qualifications
  qualifications: ['Cualificaciones y Títulos', 'Qualifications & Degrees'],
  qualifications_desc: [
    'Gestione sus títulos académicos, cédulas y licencias profesionales.',
    'Manage educational degrees, credentials, and professional licenses.',
  ],
  qualifications_title: ['Título', 'Title'],
  qualifications_list: ['Lista de Cualificaciones', 'Qualifications List'],
  qualifications_institution: ['Institución', 'Institution'],
  qualifications_category: ['Categoría', 'Category'],
  qualifications_year_of_completion: ['Año de obtención', 'Year of completion'],
  qualifications_license: ['Cédula / Licencia', 'License / Credential ID'],
  qualification_new: ['Nueva cualificación', 'New qualification'],
  qualifications_profesional: ['Profesional / Licenciatura', "Bachelor's Degree / Professional"],
  qualifications_masters: ['Maestría', "Master's Degree"],
  qualifications_doctorate: ['Doctorado', 'Doctorate'],
  qualifications_missing_fields: ['Por favor complete los campos obligatorios', 'Please fill in all required fields'],
  no_qualifications: ['No hay cualificaciones registradas.', 'No qualifications registered.'],

  // Skills
  skills: ['Habilidades y Especialidades', 'Skills & Specialties'],
  skills_desc: [
    'Configure sus competencias clínicas y años de experiencia.',
    'Configure your clinical competencies and years of experience.',
  ],
  active_skills: ['Habilidades Activas', 'Active Skills'],
  add_skill: ['Agregar Habilidad', 'Add Skill'],
  skill_name: ['Habilidad / Competencia', 'Skill / Competency'],
  skills_years_experience: ['Años de Experiencia', 'Years of Experience'],
  no_skills: ['No hay habilidades registradas.', 'No skills registered yet.'],
  skills_save_error: ['Error al actualizar las habilidades.', 'Failed to update skills.'],

  // Practice Details / Work Assignment
  practice_details: ['Detalles del Consultorio', 'Practice Details'],
  practice_details_desc: [
    'Configure horarios de atención, ubicaciones y puntos de contacto.',
    'Configure working hours, office locations, and contact points.',
  ],
  work_assignment_title: ['Asignaciones de Trabajo', 'Work Assignments'],
  new_assignment: ['Nueva Asignación', 'New Assignment'],
  no_assignments: ['No hay asignaciones de trabajo registradas.', 'No work assignments registered.'],
  interior_number: ['Número Interior', 'Interior Number'],
  slot_size: ['Duración de Cita (min)', 'Slot Size (min)'],
  manage_agenda: ['Gestionar Agenda', 'Manage Agenda'],
  contact_points: ['Puntos de Contacto', 'Contact Points'],
  add_contact: ['Agregar Contacto', 'Add Contact'],
  extension: ['Extensión', 'Extension'],
  label: ['Etiqueta', 'Label'],
  office_hours: ['Horario de Atención', 'Office Hours'],
  schedule_validation_error: [
    'El horario contiene traslapes o intervalos inválidos.',
    'Schedule contains overlaps or invalid intervals.',
  ],
  work_assignment_save_error: ['Error al guardar las asignaciones.', 'Failed to save assignments.'],

  // Assistants
  assistants: ['Gestión de Asistentes', 'Assistant Management'],
  assistants_desc: [
    'Delegue permisos para la gestión de agenda y acceso de asistentes.',
    'Delegate agenda management permissions and assistant access.',
  ],
  authorized_assistants: ['Asistentes Autorizados', 'Authorized Assistants'],
  no_assistants_found: ['No se encontraron asistentes autorizados.', 'No authorized assistants found.'],
  assistants_load_error: [
    'Ocurrió un error al cargar la lista de asistentes.',
    'An error occurred while loading the assistants list.',
  ],

  // Billing
  billing: ['Facturación y Pagos', 'Billing & Payments'],
  billing_desc: [
    'Configure métodos de pago, tarifas y preferencias de facturación.',
    'Set up payment methods, fee schedules, and invoicing preferences.',
  ],
};

export type VocabProMenuKey = keyof typeof VocabProMenu;
export default VocabProMenu;